import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";

import PaginatorStyles from "components/general/Paginator.module.scss";

export class Paginator extends Component {
  constructor (props) {
    super(props);

    this.state = {
      currentPage: parseInt(props.page),
      totalPages: Math.ceil(props.totalItems/props.perPage)
    };
    this.onPageChange = this.onPageChange.bind(this);
    this.renderPrevButton = this.renderPrevButton.bind(this);
    this.renderNextButton = this.renderNextButton.bind(this);
    this.setCurrentPage = this.setCurrentPage.bind(this);
    this.setTotalItems = this.setTotalItems.bind(this);
  }

  onPageChange () {
  }

  renderPrevButton () {
    if (this.state.currentPage > 1) {
      let url = this.props.baseUrl;
      if (this.state.currentPage > 2) {
        url += this.state.currentPage - 1;
      }

      return (
        <NavLink 
          to={url} 
          className={PaginatorStyles["paginator-button"]}>
          ‹
        </NavLink>
      );
    }

    return (
      <button className={PaginatorStyles["paginator-button"]} disabled>
        ‹
      </button>
    );
  }

  renderNextButton () {
    if (this.state.currentPage < this.state.totalPages) {
      let url = this.props.baseUrl + (this.state.currentPage + 1);

      return (
        <NavLink 
          to={url} 
          className={PaginatorStyles["paginator-button"]}>
          ›
        </NavLink>
      );
    }

    return (
      <button className={PaginatorStyles["paginator-button"]} disabled>
        ›
      </button>
    );
  }

  setCurrentPage (page) {
    this.setState({
      currentPage: parseInt(page)
    });
  }

  setTotalItems (totalItems) {
    this.setState({
      totalPages: Math.ceil(totalItems/this.props.perPage)
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.page !== this.props.page) {
      this.setCurrentPage(this.props.page);
    }

    if (prevProps.totalItems !== this.props.totalItems) {
      this.setTotalItems(this.props.totalItems);
    }
  }

  render () {
    return (
      <div className={PaginatorStyles["paginator"]}>
        <div className={PaginatorStyles["paginator-block"]}>
          {this.renderPrevButton()}
          <div className={PaginatorStyles["paginator-display"]}>
            {this.state.currentPage} de {this.state.totalPages}
          </div>
          {this.renderNextButton()}
        </div>
      </div>
    );
  }
}

Paginator.defaultProps = {
  page: 1,
  perPage: 12
};

Paginator.propTypes = {
  page: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  perPage: PropTypes.number,
  totalItems: PropTypes.number.isRequired,
  baseUrl: PropTypes.string.isRequired
};